// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// import { getAuth, GoogleAuthProvider } from "firebase/auth/cordova";
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// Required for side-effects
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBLTMHwL6RZsqtRrCL-2uOnEIcRbCIovMo",
    authDomain: "readmateapp-696eb.firebaseapp.com",
    projectId: "readmateapp-696eb",
    storageBucket: "readmateapp-696eb.appspot.com",
    messagingSenderId: "1087001713628",
    appId: "1:1087001713628:web:2ad1472539a6d1249a0d19",
    measurementId: "G-8BW1LRYSEM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const analytics = getAnalytics(app);
const googleProvider = new GoogleAuthProvider()
const db = getFirestore(app);
const storage = getStorage(app)
export { db, app, analytics, auth, googleProvider, storage };    